import type { QueryClient } from '@tanstack/react-query'
import axios from 'axios'
import { removeHeaderToken } from '@/common/lib/fetch'

export const isAuthError = (error: unknown): boolean => {
    if (!error || typeof error !== 'object') {
        return false
    }

    if ('response' in error) {
        const status = (error as { response?: { status?: number } }).response?.status
        if (status === 401 || status === 403) {
            return true
        }
    }

    if (error instanceof Error && error.message === 'error refreshing token') {
        return true
    }

    if (axios.isCancel(error)) {
        return true
    }

    return false
}

export const isServerUnavailable = (error: unknown): boolean => {
    if (!error || typeof error !== 'object') {
        return false
    }

    if ('code' in error && (error as { code?: string }).code === 'ERR_NETWORK') {
        return true
    }

    if ('response' in error) {
        const status = (error as { response?: { status?: number } }).response?.status
        if (status !== undefined && status >= 500) {
            return true
        }
    }

    return false
}

export const clearSession = (queryClient?: QueryClient): void => {
    removeHeaderToken()
    queryClient?.removeQueries({ queryKey: ['me'] })
}
